import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=16df067a&scoped=true"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"
import style0 from "./Main.vue?vue&type=style&index=0&id=16df067a&prod&scoped=true&lang=css"
import style1 from "./Main.vue?vue&type=style&index=1&id=16df067a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16df067a",
  null
  
)

export default component.exports